import { t } from 'i18next'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { Alert, Spinner } from 'react-bootstrap'
import styled from 'styled-components'
import ActivityItem from './ActivityItem'
import ModalComponent2 from '../../Modals/ModalComponent2'
import { useActivitiesState } from '../../../stores/Configuration/ActivitiesProvider'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { FixedSizeList as List } from 'react-window'
import useMountEffect from '../../../utils/hooks/useMountEffect'
import SearchField from '../../Forms/SearchField'
import NoDataAlert from '../NoDataAlert'
const StyledWrapper = styled.div`
  @media screen and (min-width: 1080px) {
    max-width: calc(100% - 480px);
    min-width: 600px;
  }
`

const ActivitiesOverview = () => {
  const {
    getActivities,
    errorStates,
    loadingStates,
    activities,
    setActivities,
    deleteActivity,
    successStates,
    setSuccessStates,
    putActivitiesOrderSequenceBackground,
  } = useActivitiesState()
  const [deleteActivityId, setDeleteActivityId] = useState('')
  const [searchText, setSearchText] = useState('')
  const [filteredActivities, setFilteredActivities] = useState(activities)
  const hasData = activities && activities.length > 0

  useMountEffect(() => {
    getActivities()
  })

  const handleSearch = (value) => {
    const lower = value.toLowerCase()
    const filtered = activities.filter((a) =>
      a.displayName.toLowerCase().includes(lower)
    )
    setFilteredActivities(filtered)
  }

  useEffect(() => {
    setFilteredActivities(activities)
  }, [activities])

  useEffect(() => {
    if (successStates.deleteActivity) {
      const timer = setTimeout(() => {
        setDeleteActivityId('')
        setSuccessStates({})
      }, 1500) 
      return () => clearTimeout(timer)
    }
  }, [setSuccessStates, successStates.deleteActivity])

  if (errorStates.activities) {
    return <Alert variant='danger'>{errorStates.activities.value}</Alert>
  }
  function move(from, to) {
    let copiedActivities = [...activities]
    let numberOfDeletedElm = 1
    const elm = copiedActivities.splice(from, numberOfDeletedElm)[0]
    numberOfDeletedElm = 0
    copiedActivities.splice(to, numberOfDeletedElm, elm)
    return copiedActivities
  }

  const moveCardHandler = (dragIndex, dropIndex) => {
    const dragItem = activities[dragIndex]
    if (dragItem) {
      const newSequence = move(dragIndex, dropIndex)
      setActivities(newSequence)
      putActivitiesOrderSequenceBackground(newSequence)
    }
  }

  const handleChangeSearch = (e) => {
    const { value } = e.target
    setSearchText(value)
    handleSearch(value)
  }
  const handleClearClick = () => {
    setSearchText('')
    setFilteredActivities(activities)
  }

  return (
    <>
      <StyledWrapper>
        {hasData && (
          <SearchField
            type='search'
            placeholder={t('assetTypes:searchInputPlaceholder')}
            value={searchText}
            className='mb-3'
            onChange={handleChangeSearch}
            onClearClick={handleClearClick}
          />
        )}

        {(loadingStates.activities && !activities.length) ||
        loadingStates.saveOrderSequence ? (
          <div className='d-flex align-items-center justify-content-center'>
            <Spinner animation='border' variant='primary' />
          </div>
        ) : !hasData ? (
          <NoDataAlert text={t('administration:noDataEntered')} />
        ) : filteredActivities.length === 0 && searchText ? (
          <div className='ps-2'>
            <strong>{t('administration:noResultsFound')}</strong>
          </div>
        ) : (
          <DndProvider backend={HTML5Backend}>
            <List
              height={800}
              itemCount={filteredActivities.length}
              itemSize={30}
            >
              {({ index, style }) => (
                <div style={style}>
                  <ActivityItem
                    key={filteredActivities[index].id}
                    index={index}
                    activity={filteredActivities[index]}
                    moveCardHandler={moveCardHandler}
                    setDeleteActivityId={setDeleteActivityId}
                  />
                </div>
              )}
            </List>
          </DndProvider>
        )}
        {loadingStates.saveOrderSequenceBackground ? (
          <div className='mt-2 d-flex align-items-center justify-content-center'>
            <Spinner animation='border' variant='primary' />
          </div>
        ) : null}
      </StyledWrapper>
      {deleteActivityId && (
        <ModalComponent2
          ModalTitle={t('activities:activityDelete')}
          BodyPart1={t('activities:deleteMessage')}
          button1Function={() => deleteActivity(deleteActivityId)}
          button1Text={!successStates.deleteActivity ? t('delete') : null}
          button1Variant='danger'
          button1Loading={loadingStates.deleteActivity}
          bodyStyle='alert alert-danger'
          functionCancel={() => {
            setDeleteActivityId('')
            setSuccessStates({})
          }}
          error={errorStates?.deleteActivity?.value}
          success={
            successStates.deleteActivity
              ? t('registrationBox:savingSuccess')
              : null
          }
        />
      )}
    </>
  )
}

export default ActivitiesOverview
